import { render, staticRenderFns } from "./ControlCard.vue?vue&type=template&id=670f0688&"
import script from "./ControlCard.vue?vue&type=script&lang=js&"
export * from "./ControlCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports